import { HEX, ProductPageType } from "common/types"

export const initialValue: ProductPageType = {
   productColor: '' as HEX,
   productQty: 1,
   productSize: '100x100',
   productUpdated: false
}